import { useEffect, useState } from 'react';
import RfpDescription from 'components/rfp/rfpInnerBox/RfpDescription';
import RfpDrag from 'components/rfp/rfpInnerBox/RfpDrag';
import allImgPaths from 'assets/images';
import ConfirmationModal from 'components/common/modal/ConfirmationModal';
import { cloneDeep } from 'lodash';

const initValues = {
    actionTitle: '',
    description: '',
    link: ''
}

const ActionCall = ({ data: dataObj, index, setItemData, removeItem, dragItem }: any) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [formData, setFormData] = useState<any>(dataObj?.content || initValues)

    useEffect(() => {
        if (dataObj?.updatedTime) {
            console.log({action: dataObj?.content})
            setFormData(dataObj?.content)
        }
    }, [dataObj?.updatedTime])

    const drag = (position: string) => {
        dragItem({ index, position })
    }

    const remove = () => {
        setShowDeleteModal(true)
    }

    const confirmDelete = () => {
        removeItem({ index })
    }

    const handleDataChange = (args: any) => {
        const updatedFormData = cloneDeep(formData);
        updatedFormData[args.key] = args.value
        setFormData(updatedFormData)
        setItemData({ index, content: updatedFormData, showLabel: false })
    }

    return (
        <>
            {
                showDeleteModal &&
                <ConfirmationModal
                    headerText={'Delete'}
                    bodyText={``}
                    setShowDeleteModal={setShowDeleteModal} confirmDelete={confirmDelete}
                />
            }
            <div className="border border-[#F0F0F0] bg-[#F9F9F9] rounded-sm flex mb-6 last:mb-6">
                <RfpDrag dragItem={drag} />

                <div className="w-full my-2 mr-2 px-6 bg-white group">
                    <div className="mb-2 flex justify-end items-center">
                        <img className='relative top-2.5 cursor-pointer invisible group-hover:visible hover:bg-[#FEE4E2] rounded w-5 p-1' src={allImgPaths.closeIconRed} alt="" onClick={remove} />
                    </div>
                    <div className="items-center gap-x-5">
                        <div>
                            <div className="mb-2 flex justify-between items-center px-0.5">
                                <span className='font-interMedium text-sm text-[#344054]'>Call to Action</span>
                            </div>

                            <div className="border border-[#D0D5DD] rounded-lg px-4 py-2 bg-[#fff] mb-5 flex items-center group hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
                                <input
                                    // onChange={handleChange}
                                    onChange={(e: any) => { handleDataChange({ key: 'actionTitle', value: e.target.value }) }}
                                    className='w-full placeholder:text-base placeholder:text-[#D0D5DD] pr-4'
                                    placeholder='Enter here'
                                    type="text"
                                    value={formData.actionTitle}
                                />
                            </div>
                        </div>
                        <div>
                            <RfpDescription
                                data={{ key: 'description', title: 'Description', content: formData?.description, updatedTime: Math.random() }}
                                handleDataChange={handleDataChange}
                            />
                        </div>
                        <div>
                            <div className="mb-2 flex justify-between items-center px-0.5">
                                <span className='font-interMedium text-sm text-[#344054]'>Link</span>
                            </div>

                            <div className="border border-[#D0D5DD] rounded-lg px-4 py-2 bg-[#fff] mb-5 flex items-center group hover:border-[#1e0af5] focus-within:border-[#1e0af5]">
                                <input
                                    // onChange={handleChange}
                                    onChange={(e: any) => { handleDataChange({ key: 'link', value: e.target.value }) }}
                                    className='w-full placeholder:text-base placeholder:text-[#D0D5DD] pr-4'
                                    placeholder='Enter here'
                                    type="text"
                                    value={formData.link}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ActionCall